import { ContentSection, SelectDirections, WikiArticles } from '@/components'
import { StyledButton, StyledContent, StyledTitle } from '@/components/styles'
import { useLoadMore, usePartialQuery } from '@/hooks'
import { useRouter } from 'next/router'
import api from '@/lib/api'
import { useTranslation } from "react-i18next";

function calcCurrentDirection(queryDirection, directions, defaultDirection) {
  if (!queryDirection) {
    return defaultDirection
  } else {
    const currentDirection = directions.reduce((acc, cur) => {
      return cur.slug === queryDirection ? cur : acc
    }, null)
    return currentDirection || defaultDirection
  }
}

export default function WikiPage(props) {
  const { directions, paginator } = props
  const router = useRouter()
  const { t } = useTranslation("global");

  const queryParams = usePartialQuery(['direction'])

  const defaultDirection = { id: 'all', title: t('wiki.allDirections'), slug: 'all' }
  const currentDirection = calcCurrentDirection(queryParams.direction, directions, defaultDirection)

  const wikiPaginator = useLoadMore(api.wiki, paginator, queryParams)

  const handleChange = type => value => {
    const nextFilter = {}
    if (value !== defaultDirection.slug) nextFilter[type] = value

    router.push(
      { pathname: router.pathname, query: { ...nextFilter } },
      { pathname: location.pathname, query: { ...nextFilter } },
      { shallow: true },
    )
  }

  return (
    <StyledContent>
      <StyledContent.Container>
        <StyledContent.Columns>
          <div>
            <StyledContent.Side>
              <StyledTitle mb="medium" as="h1">
              {t('wiki.title')}
              </StyledTitle>

              <SelectDirections
                directions={[defaultDirection, ...directions]}
                active={currentDirection}
                onChange={handleChange('direction')}
                disabled={wikiPaginator.loading}
                scrollTop
              />
            </StyledContent.Side>
          </div>
          <StyledContent.ColumnMain>
            <StyledContent.Loadable isLoading={wikiPaginator.loading}>
              {wikiPaginator.items && wikiPaginator.items.length > 0 ? (
                <ContentSection noTitle>
                  <WikiArticles data={wikiPaginator.items} />
                </ContentSection>
              ) : (
                <StyledContent.Empty>
                  {t('wiki.empty')}
                </StyledContent.Empty>
              )}

              {wikiPaginator.hasMore && (
                <StyledContent.LoadBtn>
                  <StyledButton light onClick={wikiPaginator.handleLoadMore}>
                  {t('showMore')}
                  </StyledButton>
                </StyledContent.LoadBtn>
              )}
            </StyledContent.Loadable>
          </StyledContent.ColumnMain>
        </StyledContent.Columns>
      </StyledContent.Container>
    </StyledContent>
  )
}
